import { api } from "@/lib/api";
import { readConsent } from "@/lib/consent";

let ready = null;

// REQ-755: the pixel script loads only after advertising consent, and only when the server has a real pixel id.
export function loadPixel() {
  if (!readConsent()?.ads) return Promise.resolve(false);
  if (!ready)
    ready = api.get("/meta/config").then((r) => {
      const id = r.data.pixel_id;
      if (!id) {
        ready = null;
        return false;
      }
      /* eslint-disable */
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      /* eslint-enable */
      window.fbq("init", id);
      window.fbq("track", "PageView");
      return true;
    }).catch(() => { ready = null; return false; });
  return ready;
}

// REQ-756: same event_id as the server event so Meta deduplicates.
export const metaTrack = (name, eventId) => {
  if (!eventId || !readConsent()?.ads) return;
  loadPixel().then((ok) => ok && window.fbq && window.fbq("track", name, {}, { eventID: eventId }));
};
